import React, { useCallback, useMemo } from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { applicationStore } from '../../../store/applicationStore';

import { isMobile } from '../../../core/helpers/isMobile';
import useTranslation from '../../../core/hooks/useTranslation';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { ValidationType } from '../../../core/constants/validationType';

const SpinResponseMessage = observer(({ notificationInfo, operatorError }) => {
  const { isOperatorHandlesErrors } = applicationStore;

  const t = useTranslation();

  const { spinResponseNotificationIcon, spinResponseNotificationBg } = useMemo(() => {
    return getGameImages();
  }, []);

  const notificationText = useCallback((validationType) => {
    if (validationType === ValidationType.MoneyTransactionError) {
      return applicationStore.canvasTranslationKeys.BET_NOT_ACCEPTED;
    }
    return applicationStore.canvasTranslationKeys.TECHNICAL_ISSUES;
  }, []);

  if (isOperatorHandlesErrors) {
    return null;
  }

  return (
    <Container x={isMobile() ? 190 : 1080} y={isMobile() ? 80 : 70}>
      <Sprite texture={spinResponseNotificationBg} alpha={0.8} anchor={0.5} x={170} y={24} />
      <Sprite texture={spinResponseNotificationIcon} anchor={0.5} x={19} y={24} />
      <Text
        text={
          operatorError ? operatorError.errorDescription : t(notificationText(notificationInfo))
        }
        x={46}
        y={25}
        resolution={2}
        anchor={{ y: 0.5 }}
        style={{
          _fontSize: 14,
          _wordWrap: true,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _wordWrapWidth: 280,
          _fontFamily: 'poppinsMedium',
        }}
      />
    </Container>
  );
});
export default SpinResponseMessage;
